import { Button, ButtonSize, ButtonVariant } from "../Button/Button";

interface DropdownFooterProps {
  totalCount?: number;
  handleClearAll: () => void;
  handleAccept: () => void;
}

const DropdownFooter = ({ totalCount, handleClearAll, handleAccept }: DropdownFooterProps) => {
  return (
    <div className="flex w-full flex-col items-center gap-3 bg-white px-2 pb-2">
      <div className="h-px w-full bg-grey-300" />
      <div className="flex w-full items-center justify-between">
        <span className="text-sm text-grey-600">{totalCount ?? 0} Selected</span>
        <div className="flex gap-2">
          <Button onClick={handleClearAll} size={ButtonSize.SMALL} variant={ButtonVariant.GHOST}>
            Clear
          </Button>
          <Button onClick={handleAccept} size={ButtonSize.SMALL}>
            Done
          </Button>
        </div>
      </div>
    </div>
  );
};

export { DropdownFooter };
